module.exports = __webpack_public_path__ + "static/media/generalIcon.8f1339dc.svg";